var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { backupConfig, defaultFlow } from "../configs/flows";
import { pages } from "../configs/pages";
import { getDfFromStorage, removeFromStorage, removeFromFormData, getJsonItem, setJsonItem, safeLocalStorageGetItem, safeLocalStorageSetItem } from "./helperLib";
import { checkAll, logicFnCheck, DEFAULT_LTV_RATIO, clampCashOutValueIfNeeded, parseUpstreamCashOutAmounts } from "./validation";
import { campaign } from "./../services/configs";
import { getFormConfig } from "./api";
import { isAgentSearchField, validateAgentSearchValue } from "./agentSearchUtils";
var getHardcodedConfig = function () {
    try {
        return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("hardcodedConfig")) || null;
    }
    catch (_a) {
        return null;
    }
};
export function getFlowConfig() {
    return __awaiter(this, arguments, void 0, function (flowId) {
        var hardcodedConfig, _a;
        if (flowId === void 0) { flowId = defaultFlow; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    hardcodedConfig = getHardcodedConfig();
                    hardcodedConfig && console.log("Using hardcoded config");
                    if (!hardcodedConfig) return [3 /*break*/, 1];
                    _a = getBackupFlowConfig(flowId);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchFlowConfig(flowId)];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/, _a];
            }
        });
    });
}
export function fetchFlowConfig() {
    return __awaiter(this, arguments, void 0, function (flowId) {
        var data, error_1;
        if (flowId === void 0) { flowId = defaultFlow; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getFormConfig(flowId)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data[0]];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching form:", error_1);
                    return [2 /*return*/, getBackupFlowConfig(flowId)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getBackupFlowConfig(fullUrlId) {
    var _a;
    var urlId = ((_a = fullUrlId.split('/df/').pop()) === null || _a === void 0 ? void 0 : _a.replaceAll('/', '')) || defaultFlow; //default id if invalid
    return backupConfig[fullUrlId] || backupConfig[urlId] || backupConfig[defaultFlow];
}
export function getPageConfig(pageId) {
    return pages[pageId]; //update to pageCollection
}
export function getFieldConfig(fieldId) {
    var sessionDf = getDfFromStorage();
    var questionsList = sessionDf.config.questionCollection;
    var fieldConfig = questionsList[fieldId];
    if (fieldConfig === undefined) {
        throw new Error("Field config not found for id: ".concat(fieldId));
        // return null;
    }
    return fieldConfig;
}
export function getValidationRuleValue(config, ruleName) {
    var rules = config.validation || [];
    var match = rules.find(function (r) { return Array.isArray(r) && r[0] === ruleName; });
    return match ? Number(match[1]) : undefined;
}
export function getLtvRatioFromFieldConfig(config) {
    var _a;
    return (_a = getValidationRuleValue(config, "ltvRatio")) !== null && _a !== void 0 ? _a : DEFAULT_LTV_RATIO;
}
export function isCashOutField(fieldId) {
    return !!(fieldId === null || fieldId === void 0 ? void 0 : fieldId.endsWith("cashOutAmt"));
}
export function isUpstreamCashOutField(fieldId) {
    return !!(fieldId === null || fieldId === void 0 ? void 0 : fieldId.endsWith("homeValueAmt")) || !!(fieldId === null || fieldId === void 0 ? void 0 : fieldId.endsWith("loanAmt_R"));
}
export function findCashOutFieldIds(formData) {
    return Object.keys(formData).filter(function (key) {
        var _a, _b, _c;
        return key.endsWith("cashOutAmt") ||
            ((_c = (_b = (_a = formData[key]) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.fieldId) === null || _c === void 0 ? void 0 : _c.endsWith("cashOutAmt"));
    });
}
export function clampDependentCashOutFields(formData) {
    var _a;
    var _b = parseUpstreamCashOutAmounts(formData), homeValue = _b.homeValue, loanAmt = _b.loanAmt;
    var updates = {};
    for (var _i = 0, _c = findCashOutFieldIds(formData); _i < _c.length; _i++) {
        var cashOutFieldId = _c[_i];
        var field = formData[cashOutFieldId];
        var currentValue = field === null || field === void 0 ? void 0 : field.fieldValue;
        if (!currentValue)
            continue;
        var config = (_a = field.config) !== null && _a !== void 0 ? _a : getFieldConfig(cashOutFieldId);
        var ltvRatio = getLtvRatioFromFieldConfig(config);
        var _d = clampCashOutValueIfNeeded(currentValue, homeValue, loanAmt, ltvRatio), clampedValue = _d.clampedValue, didClamp = _d.didClamp;
        if (!didClamp)
            continue;
        var _e = isFieldValid(clampedValue, config), valid = _e.valid, errorMsg = _e.errorMsg;
        updates[cashOutFieldId] = __assign(__assign({}, field), { fieldValue: clampedValue, isValid: valid, errorMessage: errorMsg });
    }
    return updates;
}
/**
 * Helpeer function to validate a field value against its configuration rules.
 * @param fieldValue : value of the field to validate
 * @param config : field configuration containing validation rules
 * @returns : { valid: boolean, errorMsg: string }
 */
export var isFieldValid = function (fieldValue, config) {
    var _a;
    var rules = [];
    if (isAgentSearchField(config)) {
        var errorMsg_1 = validateAgentSearchValue(fieldValue, config);
        return errorMsg_1 ? { valid: false, errorMsg: errorMsg_1 } : { valid: true, errorMsg: "" };
    }
    else if (Array.isArray(config.validation))
        rules = config.validation;
    else if (config.validation)
        rules = [config.validation];
    else
        rules = ["required"];
    // For cashOutAmt fields: inject the ltvRatio cross-field validator if the CMS has
    // not already added one. getFieldConfig returns a fresh JSON.parse result on every
    // call, so this is the only place the injection reliably survives all re-renders.
    if (((_a = config.fieldId) === null || _a === void 0 ? void 0 : _a.endsWith("cashOutAmt")) &&
        !rules.some(function (r) { return Array.isArray(r) && r[0] === "ltvRatio"; })) {
        rules = __spreadArray(__spreadArray([], rules, true), [["ltvRatio", DEFAULT_LTV_RATIO]], false);
    }
    var errorMsg = checkAll(rules, fieldValue);
    return errorMsg ? { valid: false, errorMsg: errorMsg } : { valid: true, errorMsg: "" };
};
/**
 * Function to validate all fields in a page based on the page configuration.
 * @param formData : current form data being passed in from page
 * @param config : page configuration containing list of questions to validate
 * @returns : { valid: boolean, errorMsg: string }
 */
export var isPageValid = function (formData, pageQuestions) {
    var hasError = pageQuestions.some(function (qId) { var _a; return !((_a = formData[qId]) === null || _a === void 0 ? void 0 : _a.isValid) || false; });
    return hasError ? { valid: false, errorMsg: 'Please correct page inputs.' } : { valid: true, errorMsg: '' };
};
/**
 * TODO: full form validation to be implemented
 * @param fieldValue
 * @param config
 * @returns
 */
export var isFormValid = function (fieldValue, config) {
    var rules = config.validation || ['required'];
    var errorMsg = checkAll(rules, fieldValue);
    return errorMsg ? { valid: false, errorMsg: errorMsg } : { valid: true, errorMsg: '' };
};
/**
 * check if a page should be included in the flow based on its config visibility conditions
 * @param pageConfig : page configuration object to be checked for visibility
 * @returns true for visible, false for not visible
 */
export var checkPageVisible = function (pageConfig) {
    if (typeof (pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.visible) === 'boolean') {
        return pageConfig.visible;
    }
    else {
        var result = logicFnCheck(pageConfig === null || pageConfig === void 0 ? void 0 : pageConfig.visible);
        // When Visible fails then remove session value of multi level nested questions
        if (!result) {
            removeFromStorage(pageConfig.questions[0]);
            removeFromFormData(pageConfig.questions[0]);
        }
        return result;
    }
};
export var getVisibleFieldsFromPage = function (pageConfig) {
    var visibleFields = [];
    return visibleFields;
};
export var checkFieldVisible = function (fieldConfig) {
    if (typeof (fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.visible) === 'boolean') {
        return fieldConfig.visible;
    }
    else {
        var result = logicFnCheck(fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.visible);
        return result;
    }
};
export var getHeardAboutUsSource = function (loanType) {
    if (typeof loanType != "string" || (loanType.toLowerCase() != 'purchase' && loanType.toLowerCase() != 'refinance')) {
        console.error('loanType Unexpected Value: ' + loanType);
        return "";
    }
    var loan_type = loanType.toLowerCase();
    var touch = (safeLocalStorageGetItem('PPC_LT_refinance') || safeLocalStorageGetItem('PPC_LT_purchase')) ?
        'PPC_LT_' :
        'PPC_FT_';
    //Currently these are the only 2 possible AdWords FT/LT Camapaign Codes:
    var purchTouch = safeLocalStorageGetItem(touch + 'purchase') != null ? parseInt(safeLocalStorageGetItem(touch + 'purchase')) : "";
    var refiTouch = safeLocalStorageGetItem(touch + 'refinance') != null ? parseInt(safeLocalStorageGetItem(touch + 'refinance')) : "";
    // console.log(purchTouch + '~' + loan_type);
    if (purchTouch == campaign.Adwords_Purch ||
        refiTouch == campaign.Adwords_Refi) {
        return "ADWORDS" + loan_type;
    }
    //conditions to check for isSEOLead flag?? page
    if (safeLocalStorageGetItem("PriorSeoEntrancePage") != null &&
        safeLocalStorageGetItem(touch + loan_type) == null) {
        return "SEO" + loan_type;
    }
    return loan_type;
};
export var normalizePhone = function (num) {
    if (!num)
        return "";
    var digits = num.replace(/\D/g, "");
    if (digits.length === 10) {
        return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
    }
    return num; // Already formatted (like "(999) 999-9999")
};
// FT/LT Logic
export var runFTLTLogic = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var refinanceRaw = urlParams.get("refinance");
    var purchaseRaw = urlParams.get("purchase");
    var phoneRaw = urlParams.get("phone");
    var gclidRaw = urlParams.get("gclid");
    var guidRaw = urlParams.get("guid");
    var fullUrl = window.location.href;
    var currentDateTime = new Date().toUTCString();
    var isValidNumber = function (value) {
        return !!value && /^\d+$/.test(value);
    };
    var hasValidData = function (data) {
        return data !== null && data !== undefined && data !== "";
    };
    var setLocalStorageWithPrefix = function (prefix, _a) {
        var refinance = _a.refinance, purchase = _a.purchase, phone = _a.phone, url = _a.url, date = _a.date, gclid = _a.gclid;
        safeLocalStorageSetItem("".concat(prefix, "pageurl"), url);
        safeLocalStorageSetItem("".concat(prefix, "refinance"), refinance || "");
        safeLocalStorageSetItem("".concat(prefix, "purchase"), purchase || "");
        safeLocalStorageSetItem("".concat(prefix, "date"), date);
        safeLocalStorageSetItem("".concat(prefix, "phone"), phone || "");
        if (phone) {
            safeLocalStorageSetItem("phoneDisplay", phone);
        }
        safeLocalStorageSetItem("gclid", gclid || "");
    };
    var guidPhoneMap = window.guidPhoneMap || {};
    var isValidPhone = phoneRaw && isValidNumber(phoneRaw) && phoneRaw.length === 10;
    var phoneToUse = null;
    if (hasValidData(guidRaw) && guidPhoneMap[guidRaw]) {
        phoneToUse = guidPhoneMap[guidRaw];
    }
    else if (isValidPhone) {
        phoneToUse = phoneRaw;
    }
    var isValidRefinance = refinanceRaw && isValidNumber(refinanceRaw);
    var isValidPurchase = purchaseRaw && isValidNumber(purchaseRaw);
    var prefix = isValidRefinance &&
        isValidPurchase &&
        hasValidData(safeLocalStorageGetItem("PPC_FT_refinance")) &&
        hasValidData(safeLocalStorageGetItem("PPC_FT_purchase"))
        ? "PPC_LT_"
        : "PPC_FT_";
    if (isValidRefinance && isValidPurchase) {
        setLocalStorageWithPrefix(prefix, {
            refinance: refinanceRaw,
            purchase: purchaseRaw,
            phone: phoneToUse,
            url: fullUrl,
            date: currentDateTime,
            gclid: hasValidData(gclidRaw) ? gclidRaw : "",
        });
    }
    else if (isValidRefinance || isValidPurchase) {
        setLocalStorageWithPrefix(prefix, {
            refinance: isValidRefinance ? refinanceRaw : "",
            purchase: isValidPurchase ? purchaseRaw : "",
            phone: phoneToUse,
            url: fullUrl,
            date: currentDateTime,
            gclid: hasValidData(gclidRaw) ? gclidRaw : "",
        });
    }
    else if (phoneToUse) {
        safeLocalStorageSetItem("phoneDisplay", phoneToUse);
    }
};
export function getEstPriceForState(stateOrCode) {
    return __awaiter(this, void 0, void 0, function () {
        var states, isStateCode, _i, _a, stateInfo, stateInfo;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    states = getJsonItem("statesData", localStorage);
                    if (!!states) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchStatesData("https://fchmsn.files.cmp.optimizely.com/download/assets/MedianPriceByState.json/dcf6b706b4b811f0ba522a002ee74cd2")];
                case 1:
                    states = _b.sent();
                    setJsonItem("statesData", states, localStorage);
                    _b.label = 2;
                case 2:
                    isStateCode = stateOrCode.length === 2;
                    if (isStateCode) {
                        for (_i = 0, _a = Object.values(states); _i < _a.length; _i++) {
                            stateInfo = _a[_i];
                            if (stateInfo.AA === stateOrCode) {
                                return [2 /*return*/, stateInfo.avg];
                            }
                        }
                        return [2 /*return*/, null];
                    }
                    else {
                        stateInfo = states[stateOrCode];
                        if (stateInfo) {
                            return [2 /*return*/, stateInfo.avg];
                        }
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function getUserGeoInfo() {
    var info = getJsonItem("userGeoInfo", localStorage);
    if (!info) {
        fetchGeoInfo();
    }
}
export function fetchGeoInfo() {
    return __awaiter(this, void 0, void 0, function () {
        var resp, data, info, e_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("https://ipinfo.io/geo?token=e7ad35d83b2fc8")];
                case 1:
                    resp = _e.sent();
                    if (!resp.ok) {
                        throw new Error("HTTP error: ".concat(resp.status));
                    }
                    return [4 /*yield*/, resp.json()];
                case 2:
                    data = _e.sent();
                    console.log(data);
                    info = {
                        User_Ip: data.ip,
                        User_City: (_a = data.city) !== null && _a !== void 0 ? _a : '',
                        User_State: (_b = data.region) !== null && _b !== void 0 ? _b : '',
                        User_Zipcode: (_c = data.postal) !== null && _c !== void 0 ? _c : '',
                        User_Country: (_d = data.country) !== null && _d !== void 0 ? _d : '',
                    };
                    localStorage.setItem("ipAddress", data.ip);
                    if (info.User_Country == "US") {
                        localStorage.setItem("userGeoInfo", JSON.stringify(info));
                        // console.log("State : Obtained from ipinfo.io");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _e.sent();
                    console.error('UserGeoInfo: error fetching geo info', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function fetchStatesData(url) {
    return __awaiter(this, void 0, void 0, function () {
        var resp, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url)];
                case 1:
                    resp = _a.sent();
                    if (!resp.ok) {
                        throw new Error("Failed to fetch data from ".concat(url, ": ").concat(resp.status, " ").concat(resp.statusText));
                    }
                    return [4 /*yield*/, resp.json()];
                case 2:
                    data = (_a.sent());
                    return [2 /*return*/, data];
            }
        });
    });
}
